module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vabdo1-f00418fdd186fa73793b6743d45978b9.jpg";